import React from "react";
import Helpers from "../../../helpers/helperFunctions";
import {t} from "../../../helpers/translator";
import KeyboardInput from "../InputKeyboard";

export default function ticketInTemplate () {
    let {terminalBalance, data, enableTitoArgs} = this.props,
        authData = JSON.parse(sessionStorage.getItem("balance")),
        balance = authData.session_balance,

        letters = /^(?!.*([QqWw])\1\1)[a-pr-vy-zA-PR-VY-Z]*$/;

    const { currency = 'EUR' } = JSON.parse(sessionStorage.getItem('authData'));
    return <div className="ticket-results-view-p">
        <form className="ticketin-popup">
            <div className="popup-contain-table-m login-form-m">
                <div className="registor-contain-form-d">
                    <div className="reg-cont-box">
                        <div className="single-form-item">
                            <KeyboardInput type='text' placeholder={t('NAME')} name="name" onChange={this.handleNameChange}/>
                            {(this.state.Name.length !== 0 && (this.state.Name.length < 3 || !this.state.Name.match(letters))) && <p className='field-is-not-correct'>{t("Contain at least 3 charachters and only letter")}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <form className="ticketin-popup">
            <div className="popup-contain-table-m login-form-m">
                <div className="registor-contain-form-d">
                    <div className="reg-cont-box">
                        <div className="single-form-item">
                            <KeyboardInput type='text' placeholder={t('SURNAME')} name="surname" onChange={this.handleSurNameChange}/>
                            {(this.state.Surname.length !== 0 && (this.state.Surname.length < 3 || !this.state.Surname.match(letters))) && <p className='field-is-not-correct'>{t("Contain at least 3 charachters and only letter")}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <form className="ticketin-popup">
            <div className="popup-contain-table-m login-form-m">
                <div className="registor-contain-form-d">
                    <div className="reg-cont-box">
                        <div className="single-form-item">
                            <KeyboardInput type='text' placeholder='CNP' name="cnp" onChange={this.handleCnpChange}/>
                            {(this.state.CNP !== '' && !Helpers.validateCNP(this.state.CNP)) && <p className='field-is-not-correct'>{t("CNP is not correct")}</p>}
                            {(this.state.CNP !== '' && Helpers.validateCNP(this.state.CNP) && !Helpers.isCNP18plus(this.state.CNP)) && <p className='field-is-not-correct'>{t("You need to be over 18")}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        {/* {(!this.props.isAdminLoggedIn || !this.isFormValid()) && <p>{t("Please ask administrator for confirmation")}</p>} */}
        {(!this.props.isAdminLoggedIn) && <p>{t("Please ask administrator for confirmation")}</p>}
        {
            this.props.tickets && this.props.tickets.length > 0
                ? <button className="button-view-normal-m"
                    onClick={this.addToBalance}
                    disabled={!(this.isInputValid(this.state.Name, this.state.Surname) && this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP))}
                >
                    {t("Confirm")}
                </button> : null
        }
        {data && data.WinId
            ? <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) ? "button-view-normal-m" : "button-view-normal-m trans-m"}
                                disabled={!(this.isInputValid(this.state.Name, this.state.Surname) && this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP))}
                                onClick={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) && this.addCasinoWinAmount()}>
                                {t("confirm cashout")}
                            </button>
                        </div>
                    </li>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m trans-m" onClick={this.props.closePopup()}>
                                {t("Cancel")}
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            : data && data.cashout_amount ? (
                <div className="buttons-view-w-t">
                    <ul>
                        <li>
                            <div className="separator-box-buttons-m">
                                <button className={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) ? "button-view-normal-m" : "button-view-normal-m trans-m"}
                                    disabled={!(this.isInputValid(this.state.Name, this.state.Surname) && this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP))}
                                    onClick={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) && this.cashoutDepositMoney()}>
                                    {t("confirm cashout")}
                                </button>
                            </div>
                        </li>
                        <li>
                            <div className="separator-box-buttons-m">
                                <button className="button-view-normal-m trans-m" onClick={this.cancel}>
                                    {t("Cancel")}
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>)
                : data && (<div className="buttons-view-w-t">
                    <ul>
                        <li>
                            <div className="separator-box-buttons-m">
                                <button className={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) ? "button-view-normal-m" : "button-view-normal-m trans-m"}
                                    disabled={!(this.isInputValid(this.state.Name, this.state.Surname) && this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP))}
                                    onClick={(this.props.isAdminLoggedIn && this.isFormValid() && Helpers.validateCNP(this.state.CNP) && Helpers.isCNP18plus(this.state.CNP)) && this.depositMoney()}>
                                    {t("Confirm")}
                                </button>
                            </div>
                        </li>
                        <li>
                            <div className="separator-box-buttons-m">
                                <button className="button-view-normal-m trans-m" onClick={this.cancel}>
                                    {t("Cancel")}
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>)
        }
    </div>;
}